module.exports = __webpack_public_path__ + "img/d200808-2.d7607227.jpg";